<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Actualizar Referencia</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="UPDATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar cambios</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid max-w-screen-md vstack gap-3">
                    <div>
                        <small class="input-title">Referencia</small>
                        <textarea class="form-control form-control-sm" v-model="data.description" :class="errors.description ? 'is-invalid' : ''"></textarea>
                        <small class="invalid-feedback" v-for="(error, index) in errors.description" :key="index">{{ error }}</small>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
export default{
    data(){
        return{
            data: {},
            errors: {},
            count: 0,
            id: this.$route.params.id,
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/sources/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        UPDATE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/sources/' + vue.id, method: 'PUT', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'SourceIndex' })
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>